module.exports = __webpack_public_path__ + "8a731cbc2f690d74704a7da71addcbf3.svg";